import { IFilter } from '@pages/Products/Products';

export const countFilter = (filtersData: Partial<IFilter>): number => {
  const {
    modelsName = [],
    users = [],
    status = [],
    tags = [],
    manufactorNames = [],
  } = filtersData;
  const modelNamesCount = modelsName.filter(item => item.active).length;
  const modelAssigneeCount = users.filter(item => item.active).length;
  const modelStatusCount = status.filter(item => item.active).length;
  const tagsNameCount = tags.length;
  const manufactorNameCount = manufactorNames.filter(
    item => item.active,
  ).length;
  const startDateCount = filtersData.startDate ? 1 : 0;
  const endDateCount = filtersData.endDate ? 1 : 0;
  return (
    modelNamesCount +
    modelAssigneeCount +
    tagsNameCount +
    manufactorNameCount +
    startDateCount +
    modelStatusCount +
    endDateCount
  );
};
